import React from 'react';
import QuoteForm from '../components/QuoteForm';

const QuoteBuilder = () => {
  return (
    <div className="quote-builder-page">
      <div className="container">
        <QuoteForm />
      </div>
    </div>
  );
};

export default QuoteBuilder;